var translation = {
	"Your profile": "您的个人资料",
	"View profile": "查看个人资料",
	"Personal information": "个人信息",
	"Community information": "社区信息",
	"Workplace information": "工作场所信息",
	"Email Preferences Center": "电子邮件首选项中心",
	"Builder ID privacy & data": "Builder ID 隐私与数据",
	"About profiles": "关于个人资料",
	"Welcome back": "欢迎回来",
	"Personal email address": "个人电子邮件地址",
	Email: "电子邮件",
	Edit: "编辑",
	Save: "保存",
	"All fields marked with an asterisk (*) are required.": "所有标有星号（*）的字段均为必填字段。",
	"Choose an option": "选择一个选项",
	"Visible to others": "对其他人可见",
	"Fields in this section will be visible to others.": "此部分中的字段将对其他人可见。",
	"Display name": "显示名称",
	Alias: "别名",
	Bio: "个人简介",
	"Github profile": "Github 个人资料",
	"Youtube profile": "Youtube 个人资料",
	"Facebook profile": "Facebook 个人资料",
	"re:Post profile": "re:Post 个人资料",
	"Dev:to profile": "Dev:to 个人资料",
	"Link to blog": "链接到博客",
	"LinkedIn profile": "LinkedIn 个人资料",
	"X profile": "X 个人资料",
	Social: "社交媒体",
	Username: "用户名",
	"Add social link": "添加社交链接",
	"Interest & background information": "兴趣和背景信息",
	"Manage your interests and other information that are used in recommending content. ": "管理您的兴趣和其它用于推荐内容的信息。",
	Interests: "兴趣",
	"Search interests": "搜索兴趣",
	Country: "国家/地区",
	"State/province": "州/省",
	"Role type": "职位类型",
	"Industry focus": "行业关注领域",
	"Level of AWS usage": "AWS 使用水平",
	"Use case focus": "使用案例关注领域",
	"Manage your work information to accurately represent your organization.": "管理您的工作信息以便准确代表您所在的组织。",
	"Business email address": "业务电子邮件地址",
	"Business phone number": "公司电话号码",
	"Company website": "公司网站",
	"Job title": "职位",
	"Company name": "公司名称",
	"Company type": "公司类型",
	"Company size": "公司规模",
	"Project timeline": "项目时间线",
	"Powered by Profile": "由个人资料提供支持",
	About: "关于",
	"Make your profile": "创建您的个人资料",
	Profile: "个人资料",
	"Get started": "开始使用",
	"Manage your information and preferences that are used to improve select AWS experiences.": "管理您的用于改善精选 AWS 体验的信息和首选设置。",
	"Sign in/Get started": "登录/开始",
	"Key things to know": "须知要点",
	"Access experience": "访问体验",
	"Control your data": "控制您的数据",
	"Read about privacy": "阅读有关隐私的信息",
	"Email preference center": "电子邮件首选项中心",
	"This field is required.": "此字段为必填字段。",
	"Your profile helps improve your interactions with select AWS experiences.": "您的个人资料有助于改善您与精选 AWS 体验的交互。",
	City: "城市",
	"Page topics": "页面主题",
	"User information": "用户信息",
	"Full name": "全名",
	Discard: "放弃",
	Link: "链接",
	"Short bio": "个人简介",
	"Add interest": "添加兴趣",
	"Unsaved changes": "未保存的更改",
	"Please make a change before saving.": "请先进行更改，然后再保存。",
	"Changes could not be saved.": "无法保存更改。",
	"Your information has been saved.": "您的信息已保存。",
	"Your new Profile Picture": "您的新个人资料头像",
	"Profile Picture": "个人资料头像",
	"Your profile picture makes you easily recognizable and shows when you're signed in.": "您的个人资料头像会在登录后显示，用来让您更容易被人识别。",
	Cancel: "取消",
	"Save profile picture": "保存个人资料头像",
	"Change profile picture": "更改个人资料头像",
	"Remove profile picture": "删除个人资料头像",
	Zoom: "缩放",
	"20MB maximum file size, only .jpg, .jpeg, .png, .webp file types supported": "最大文件大小为 20MB，仅支持 .jpg、.jpeg、.png、.webp 文件类型",
	"Drag and drop": "拖放",
	"or browse files": "或浏览文件",
	"or Browse files (browse files is link to open files)": "或“浏览文件”（“浏览文件”是用于打开文件的链接）",
	"There was an error processing your profile picture, please try again.": "处理您的个人资料头像时出错，请重试。",
	"Your profile picture has been updated.": "您的个人资料头像已更新。",
	"File size above 20MB.": "文件大小超过 20MB。",
	"Invalid file type.": "文件类型无效。",
	"An error occurred.": "出现错误。",
	"Click or drag file to this area (backup from community in case we change our mind on drag and drop text)": "单击或拖动文件到此区域（从社区进行备份，以防我们对拖放的文本改变处理方式）",
	"I agree to the terms of the <a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "我同意 <a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS 客户协议</a> 和<a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">个人信息收集和使用声明</a>中的条款。",
	"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf": "https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf",
	"Sign into your profile": "登录您的个人资料",
	"Sign in": "登录",
	"First name": "名",
	"Last name": "姓",
	"Phone number": "电话号码",
	"Postal code": "邮政编码",
	"Business address": "公司地址",
	Select: "选择",
	"Enter text": "输入文本",
	"Business Interests": "业务兴趣",
	"Personal Interests": "个人兴趣",
	"Manage your email through <a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS Builder ID</a>": "通过 <a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS Builder ID</a> 管理您的电子邮件",
	"Manage information that other members in the community will see when you create content on <a class=\"link\" href=\"https://builder.aws.com\">Builder Center</a> or leave comments on <a class=\"link\" href=\"https://aws.amazon.com/blogs\">AWS Blogs</a>.": "管理当您在 <a class=\"link\" href=\"https://builder.aws.com\" target=\"_blank\" rel=\"noopener noreferrer\">Builder Center</a> 上创建内容以及在 <a class=\"link\" href=\"https://aws.amazon.com/blogs\" target=\"_blank\" rel=\"noopener noreferrer\">AWS Blog</a> 上发表评论时，社区中其他成员将看到的信息。",
	"Profile is used to improve select AWS experiences. <a href=#>Learn more</a>": "个人资料用于改善精选 AWS 体验。<a href=#>了解详情</a>",
	"Profile is currently connected to select experiences, which includes <a href=#1>Builder Center</a>, <a href=#2>AWS Blogs</a>, <a href=#3>AWS Startups</a>, select forms and surveys on AWS Pulse, and select online webinar registrations and content downloads. ": "个人资料目前连接到精选体验，其中包括 <a href=#1 rel=\"noopener noreferrer\" target=\"_blank\">Builder Center</a>、<a href=#2 rel=\"noopener noreferrer\" target=\"_blank\">AWS Blog</a>、<a href=#3 rel=\"noopener noreferrer\" target=\"_blank\">AWS Startups</a>、AWS Pulse 上的精选表单和调查，以及精选的线上网络研讨会注册和内容下载。",
	"You can access and update your profile at anytime by going to <a href=#>Profile</a>.": "您可以随时访问<a href=#>个人资料</a>并更新您的个人资料。",
	"There are unsaved changes in the <a href=\"#\">{{profile}}</a> section. Would you like to save or discard?": "<a href=\"#\">{{profile}}</a> 部分中有未保存的更改。您要保存还是放弃更改？",
	or: "或",
	"browse files": "浏览文件",
	"Claim your alias": "认领您的别名",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias cannot be changed after claiming.": "您的别名将对我们社区的所有成员可见，这是其他开发者与您联系的方式。别名在认领后无法更改。",
	"Enter your alias": "输入您的别名",
	"Your alias must be 3 to 19 alphanumeric characters (contains only a-z, 0-9) and not violate our <a className=\"link\" href=\"#\" target=\"_blank\"> Terms and Services </a>.": "您的别名必须是3到19个字母数字字符（仅包含a-z、0-9），且不违反我们的<a className=\"link\" href=\"#\" target=\"_blank\">服务条款</a>。",
	"Are you sure you want to claim? This action cannot be undone.": "您确定要认领吗？此操作无法撤消。",
	Claim: "认领",
	Claimed: "已认领",
	"Checking availability": "正在检查可用性",
	Claiming: "认领中",
	"Alias must be 3 to 19 characters.": "别名必须是3到19个字符。",
	"Alias must only contain alphanumeric characters (a-z, 0-9).": "别名只能包含字母数字字符（a-z、0-9）。",
	"Alias is already claimed.": "该别名已被认领。",
	"Unable to save your content.": "无法保存您的内容。",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias <b>cannot</b> be changed after claiming.": "您的别名将对我们社区的所有成员可见，这是其他开发者与您联系的方式。别名在认领后<b>无法</b>更改。",
	"Please ensure all fields adhere to our <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">Code of Conduct</a> before trying again.": "在重试之前，请确保所有字段都符合我们的<a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">行为准则</a>。",
	"If you're still having trouble, feel free to <a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">contact us</a> for assistance.": "如果您仍然遇到问题，请随时<a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">联系我们</a>获取帮助。",
	"Having trouble saving content?": "保存内容时遇到问题？",
	"Checking alias availability was not successful. Please try again.": "检查别名可用性失败。请重试。",
	"This field contains invalid characters.": "此字段包含无效字符。",
	"Select up to 10 interests": "最多选择10个兴趣",
	"Must be 7-15 digits.": "必须为7-15位数字。",
	"Invalid postal code. Postal codes may include only letters (A-Z and a-z), numbers (0-9), dashes (-), and spaces.": "邮政编码无效。邮政编码只能包含字母（A-Z和a-z）、数字（0-9）、破折号（-）和空格。",
	"This name is not valid. Names can include only letters (A-Z and a-z), numbers (0-9), dashes (-), and periods (.).": "此名称无效。名称只能包含字母（A-Z和a-z）、数字（0-9）、破折号（-）和句点（.）。",
	"Invalid email address": "无效的电子邮件地址",
	"Must be 64 characters or less": "必须为64个字符或更少",
	"Must be 100 characters or less": "必须为100个字符或更少",
	"2 more interests remaining.": "还可以选择2个兴趣。",
	"1 more interest remaining.": "还可以选择1个兴趣。",
	"You've reached the maximum number of interests. To add others, please remove an existing item.": "您已达到兴趣的最大数量。要添加其他兴趣，请删除现有项目。",
	"Work city": "工作地点城市",
	"Work postal code": "工作地点邮政编码",
	"I agree to the terms of the <a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "我同意 <a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS 客户协议</a> 和<a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">个人信息收集和使用声明</a>中的条款。",
	Emails: "电子邮件",
	"AWS Builder ID": "AWS Builder ID",
	"Additional emails let you use different email addresses for select AWS experiences, while keeping your AWS Builder ID email for sign-in.": "额外的电子邮件地址可让您在选定的 AWS 体验中使用不同的电子邮件地址，同时保留您的 AWS Builder ID 电子邮件用于登录。",
	Personal: "个人",
	Business: "商务",
	None: "无",
	"Verify email": "验证电子邮件",
	Unverified: "未验证",
	"Add email": "添加电子邮件",
	"Add an email address": "添加电子邮件地址",
	"Enter verification code": "输入验证码",
	"A 6-digit verification code has been sent to <span class=\"font-bold\">{{email}}</span>. Please enter it below to confirm your email address.": "6位验证码已发送至 <span class=\"font-bold\">{{email}}</span>。请在下方输入以确认您的电子邮件地址。",
	"Verification limit reached": "已达到验证限制",
	"You've made the maximum number of requests allowed today. Please try again after 24 hours.": "您已达到今天允许的最大请求次数。请24小时后再试。",
	Okay: "确定",
	"Delete Email": "删除电子邮件",
	"Are you sure you want to remove your email?": "您确定要删除您的电子邮件吗？",
	"Please type <span class=\"font-bold\">{{email}}</span> to continue with removal:": "请输入 <span class=\"font-bold\">{{email}}</span> 以继续删除：",
	"Didn't receive a code?": "没收到验证码？",
	"Request a new code.": "请求新验证码。",
	"Additional emails": "其他电子邮件地址",
	Type: "类型",
	Skip: "跳过",
	Submit: "提交",
	"Emails are different": "电子邮件不同",
	"Manage my AWS Builder ID": "管理我的 AWS Builder ID",
	"Your email address that you use to sign in and access different AWS experiences.": "您用于登录和访问不同 AWS 体验的电子邮件地址。",
	"Email address": "电子邮件地址",
	"Email type": "电子邮件类型",
	"AWS Builder ID email": "AWS Builder ID 电子邮件",
	"If you did not receive an email, please check your spam or junk folder.": "如果您没有收到电子邮件，请检查您的垃圾邮件文件夹。",
	"No additional emails added.": "未添加其他电子邮件。",
	"Please enter a verification code.": "请输入验证码。",
	"Verification code must be at least 6 characters": "验证码必须至少包含 6 个字符",
	"Federate email": "联合登录电子邮件",
	"This information will update existing public details that other members in the community will see across <a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>, <a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >Builder Center</a>, and comments on <a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >AWS Blogs</a>. Please make sure to follow <a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >code of conduct</a> when saving your community information.": "此信息将更新现有的公开详细信息，社区中的其他成员可以在 <a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>、<a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >Builder Center</a> 和 <a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >AWS Blogs</a> 上的评论中看到这些信息。保存社区信息时，请务必遵守<a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >行为准则</a>。",
	"Display country": "可见国家",
	"Display state": "可见州",
	Headline: "标题",
	"Email marketing preferences": "电子邮件营销首选项",
	"Select a verified email to manage your email marketing preferences.": "选择一个经验证的电子邮件来管理您的电子邮件营销首选项。",
	Manage: "管理",
	"Email preferences": "电子邮件首选项"
};
var zhCN = {
	translation: translation
};

export { zhCN as default, translation };
